import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppState } from '../store/appState';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { EXTERNAL_APIS } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class DocOperationsService {

  private baseApi = EXTERNAL_APIS.MEMBER_PORTAL_HOME;
  constructor(private http: HttpClient, private store: Store<AppState>) {
  }

  getDocument(docurl): Observable<any>  {
          var docpath = docurl.split(/(\one)/)
          const response = this.http.get(this.baseApi + docpath[2], {responseType: 'blob'});
          return response;
  }

}
